import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { getPageBySlugAndLanguage, getCmsInfoFromPath, getCmsPageRequest } from '../../CmsActions';

import VisibilitySensor from '../../../../components/VisibilitySensor/VisibilitySensor';

function PredictiveLink({ dispatch, to, href, children, tag = Link, content = null, appIsMobile = false, usePrefetch = false, ...props }) {
	const [isFetched, setIsFetched] = useState(false);

	const target = to || href;
	const Tag = tag || Link;

	const destination = getCmsInfoFromPath(target);


	const handlePreload = () => {
		if(usePrefetch) {
			setIsFetched(true);
		} else if(!content) {
			!isFetched && dispatch(getCmsPageRequest(destination.slug, destination.language, false, destination.search));
			setIsFetched(true);
		}
	};

	const handleVisibilityChange = isVisible => {
		isVisible && handlePreload();
	};

	if(appIsMobile) {
		return (
			<VisibilitySensor onChange={handleVisibilityChange}>
				<Tag to={target} href={target} {...props}>{children}</Tag>
			</VisibilitySensor>
		);
	}

	return (
		<Fragment>
			{isFetched && usePrefetch && (
				<Helmet
					link={[
						{
							rel: 'prefetch',
							href: target,
						},
					]}
				/>
			)}
			<Tag to={target} href={target} onMouseOver={handlePreload} {...props}>{children}</Tag>
		</Fragment>
	);
}

PredictiveLink.propTypes = {
	dispatch: PropTypes.func.isRequired,
	to: PropTypes.string,
	href: PropTypes.string,
	children: PropTypes.node.isRequired,
	content: PropTypes.object,
	appIsMobile: PropTypes.bool,
	usePrefetch: PropTypes.bool,
	tag: PropTypes.oneOfType([
	  PropTypes.string,
	  PropTypes.object,
	]),
};

const mapStateToProps = (store, props) => {
	const info = getCmsInfoFromPath(props.to || props.href);
	return {
		content: getPageBySlugAndLanguage(store, info.slug, info.language),
		appIsMobile: store.app.isMobile,
	};
};

export default connect(mapStateToProps)(PredictiveLink);
